import React, { useState } from "react";
import copy from "copy-to-clipboard";

import {
  Box,
  IconButton,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { FileCopyOutlinedIcon } from "@braintrust/braintrust-ui-components/Icons";

import styles from "./style.module.scss";

export const CurrentBuildData = () => {
  const [copiedRecently, setCopiedRecently] = useState(false);

  const showCopiedMessage = (time: number) => {
    setCopiedRecently(true);

    setTimeout(() => {
      setCopiedRecently(false);
    }, time * 1000);
  };

  const handleCopy = () => {
    const copiedText = `${process.env.BUILD_DATA_CURRENT_BRANCH} ${process.env.BUILD_DATA_COMMIT_HASH}`;
    void copy(copiedText);
    showCopiedMessage(3);
  };

  return (
    <Box
      className={styles.dataWrapper}
      onClick={handleCopy}
      sx={{ display: "flex", alignItems: "center" }}
    >
      {copiedRecently && (
        <Typography component="div" variant="paragraph" sx={{ mr: 1 }}>
          <span className={styles.widget}>Copied!</span>
        </Typography>
      )}
      <IconButton
        className={styles.copyButton}
        variant="secondary"
        inverse
        aria-label="Copy"
      >
        <FileCopyOutlinedIcon className={styles.icon} color="secondary" />
      </IconButton>
      <Typography
        component="div"
        variant="paragraph"
        color="secondary"
        sx={{ ml: 1 }}
      >
        <span className={styles.widget}>
          {process.env.BUILD_DATA_CURRENT_BRANCH}
        </span>
      </Typography>
      <Typography
        component="div"
        variant="paragraph"
        color="tertiary"
        sx={{ ml: 1 }}
      >
        <span className={styles.widget}>
          {process.env.BUILD_DATA_COMMIT_HASH}
        </span>
      </Typography>
    </Box>
  );
};
